import { Injectable } from '@angular/core';
import { ApiConversionHelper } from '../../helpers/api-conversion.helper';
import { Notification } from '../../types/notification.type';
import { BaseApiService } from './base-api.service';

@Injectable({ providedIn: 'root' })
export class NotificationsApiService extends BaseApiService {
  protected get baseUrl(): string {
    return `${super.baseUrl}/notifications`;
  }

  async getNotifications(tenantId: string, pageSize: number, pageIndex: number): Promise<Notification[]> {
    const result = await this.get<Notification[]>(tenantId ?? '', { pageSize, pageIndex });
    result.forEach(i => ApiConversionHelper.convertNotification(i));
    return result;
  }

  async getUnreadCount(tenantId: string): Promise<number> {
    return await this.get<number>(`unread-count${this.getTenantParameter(tenantId)}`);
  }

  async markAsRead(id: string): Promise<void> {
    return await this.patch(`${id}/is-read`, null);
  }

  async markAllAsRead(tenantId: string): Promise<void> {
    return await this.patch(`all-is-read${this.getTenantParameter(tenantId)}`, null);
  }
}
